import { render, staticRenderFns } from "./EmptyWithNavbar.vue?vue&type=template&id=333e90b3&"
import script from "./EmptyWithNavbar.vue?vue&type=script&lang=js&"
export * from "./EmptyWithNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/webapp-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
installComponents(component, {VSpacer,VToolbar})
